import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "base-title-button"
}
const _hoisted_2 = {
  key: 1,
  class: "base-title-button"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1)
const _hoisted_4 = {
  key: 2,
  class: "base-title-button"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1)
const _hoisted_6 = { class: "table table-hover align-middle mt-4" }
const _hoisted_7 = { class: "border-dark border-bottom pb-2" }
const _hoisted_8 = { class: "border-dark border-bottom" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_content_library_available = _resolveComponent("base-content-library-available")!
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_title = _resolveComponent("base-title")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_content_blocks_overview_item = _resolveComponent("content-blocks-overview-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.title || this.description || this.canUseLibrary || this.canUseModal || this.routeObjectNewCb)
      ? (_openBlock(), _createBlock(_component_base_title, {
          key: 0,
          title: this.title,
          "help-text": this.description,
          "back-route": this.routeObjectBack,
          "is-library": this.isLibrary,
          mb: 3,
          "show-refresh-button": "",
          onRefresh: _cache[1] || (_cache[1] = ($event: any) => (this.$emit('refresh')))
        }, {
          buttons: _withCtx(() => [
            (this.canUseLibrary)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_base_content_library_available, {
                    "cb-type": this.cbType,
                    "src-lib-code": this.srcLibCode,
                    title: this.title + ' ' + _ctx.$t('library'),
                    onCopied: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('copiedLibCb')))
                  }, null, 8, ["cb-type", "src-lib-code", "title"])
                ]))
              : _createCommentVNode("", true),
            (this.canUseModal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_base_modal_button, {
                    "modal-id": this.modalId,
                    class: "btn btn-hover icon-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                    ]),
                    _: 1
                  }, 8, ["modal-id"])
                ]))
              : (this.routeObjectNewCb)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_router_link, {
                      to: this.routeObjectNewCb,
                      class: "btn btn-hover icon-link"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5,
                        _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "help-text", "back-route", "is-library"]))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_6, [
      _createElementVNode("thead", _hoisted_7, [
        _createElementVNode("tr", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeaderItems, (tableHeaderItem) => {
            return (_openBlock(), _createElementBlock("th", { key: tableHeaderItem }, _toDisplayString(tableHeaderItem), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (!_ctx.isReady)
          ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
              key: 0,
              "n-cols": _ctx.tableHeaderItems.length
            }, null, 8, ["n-cols"]))
          : (!_ctx.hasContentBlocks)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeaderItems.length,
                  class: "fw-bold small text-uppercase text-muted"
                }, _toDisplayString(_ctx.$t('noContentFound')), 9, _hoisted_10)
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.contentBlocks, (contentBlock) => {
                return (_openBlock(), _createBlock(_component_content_blocks_overview_item, {
                  key: contentBlock.id,
                  onCopyContentBlock: _ctx.copyContentBlock,
                  onDeleteContentBlock: _ctx.deleteContentBlock,
                  "content-block": contentBlock,
                  "content-type": _ctx.contentType,
                  "can-copy-item": _ctx.canCopyItem,
                  "can-preview": _ctx.canPreview,
                  "modal-id": _ctx.modalId,
                  "route-object-edit-cb": _ctx.routeObjectEditCb
                }, null, 8, ["onCopyContentBlock", "onDeleteContentBlock", "content-block", "content-type", "can-copy-item", "can-preview", "modal-id", "route-object-edit-cb"]))
              }), 128))
      ])
    ])
  ], 64))
}